import { render, staticRenderFns } from "./teachersend.vue?vue&type=template&id=3875141d&scoped=true&"
import script from "./teachersend.vue?vue&type=script&lang=js&"
export * from "./teachersend.vue?vue&type=script&lang=js&"
import style0 from "./teachersend.vue?vue&type=style&index=0&id=3875141d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875141d",
  null
  
)

export default component.exports